import { Box, Link, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../../../constants/translations';
import { useCafe } from '../../../contexts/cafe.context';
import { useLocale } from '../../../contexts/locale.context';
import Step from './Step';

const Step1 = () => {
  const { lang } = useLocale();
  const navigate = useNavigate();
  const { setOpenMessages } = useCafe();

  const handleClick = useCallback(
    (route: string) => {
      navigate(route);
      setOpenMessages(false);
    },
    [navigate, setOpenMessages]
  );

  return (
    <Step number="1">
      <Typography variant="body2">{t.step1_part1[lang]}</Typography>
      <Box component="ul" sx={{ m: 0 }}>
        <Typography variant="body2" component="li">
          {t.step1_part2[lang]}{' '}
          <Link onClick={() => handleClick('./stores')} sx={{ cursor: 'pointer' }}>
            {t.stores[lang]}
          </Link>
          ;
        </Typography>
        <Typography variant="body2" component="li">
          {t.step1_part3[lang]}{' '}
          <Link onClick={() => handleClick('./products')} sx={{ cursor: 'pointer' }}>
            {t.products[lang]}
          </Link>
          ;
        </Typography>
        <Typography variant="body2" component="li">
          {t.step1_part4[lang]}{' '}
          <Link onClick={() => handleClick('./semifinished')} sx={{ cursor: 'pointer' }}>
            {t.semifinished_products[lang]}
          </Link>
          ;
        </Typography>
      </Box>
    </Step>
  );
};

export default Step1;
